export default "__VITE_ASSET__Bqr6rkP6__"